export const tr = {
    'image-download-error': 'Görsel yüklenirken hata oluştu. Daha sonra tekrar deneyin.',
    'request-error': 'Beklenmeyen hata oluştu.'
};
